import { render, staticRenderFns } from "./CandidateSideBarInfo.vue?vue&type=template&id=8b56b82c&scoped=true&"
import script from "./CandidateSideBarInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateSideBarInfo.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSideBarInfo.vue?vue&type=style&index=0&id=8b56b82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b56b82c",
  null
  
)

export default component.exports